import { Card, CardContent } from '@mui/material';
import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RotateCcw, Eye, EyeOff } from 'lucide-react';

export default function Reset() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const [password, setPassword] = useState('');
    const [cpassword, setCpassword] = useState('');
    const [error, setError] = useState('');

    const [showPassword, setShowPassword] = useState(false);
    const [showCPassword, setShowCPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    const toggleCPasswordVisibility = () => {
        setShowCPassword(!showCPassword);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
       
        const trimmedPassword = password.trim();
        const trimmedCPassword = cpassword.trim();
       
        if (!trimmedPassword) {
            toast.error('Please enter password');
            return;
        }
        
        if (trimmedPassword.length < 6) {
            toast.error('Password must be 6 characters!');
            return;
        }
        
        // Password match check
        if (trimmedPassword !== trimmedCPassword) {
            toast.error('Passwords do not match!');
            return;
        }
        
        setError("");

        try {
            const data = { password, token };
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/reset-password`, data
            );
            toast.success('Reset Password Success!');
            setTimeout(() => {
                navigate('/login');
            }, 400);
        } catch (error) {
            console.log("message", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Unable to reach the server");
            }
        }
    };

    return (
        <div
            className="h-screen bg-cover bg-center flex flex-col justify-center items-center text-white text-center px-6"
            style={{ backgroundImage: "url('/images/bg.jpg')" }}>
            
            <Card className="w-full max-w-[400px]" sx={{ borderRadius: '15px', paddingTop: '10px' }}>
                <div className="flex justify-center">
                    <img src="/images/logo.png" alt="logo" className="max-w-[100px]" />
                </div>
                
                <CardContent sx={{ paddingTop: '0px' }}>
                    <h2 className="text-xl font-semibold text-center text-[#000]">Reset Password</h2>
                    
                    <form onSubmit={handleLogin} className="space-y-4 pt-5 pb-0 px-[10px]">
                        <div className="relative">
                            <input 
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder=""
                                id="float_password" 
                                className="block w-full text-sm text-gray-900 bg-transparent rounded-lg border border-[#49bef3] appearance-none dark:border-[#49bef3] focus:outline-none focus:ring-0 focus:border-blue-600 peer dark:focus:border-blue-500" 
                            />
                            <label 
                                htmlFor="float_password" 
                                className="absolute text-sm text-[#49bef3] dark:text-[#49bef3] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                                New Password
                            </label>      
                            <div
                                className="absolute inset-y-0 right-2 flex items-center cursor-pointer"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? <Eye size={18} color='#49bef3' /> : <EyeOff size={18} color='#49bef3' />}
                            </div>
                        </div>
                        
                        <div className="relative">
                            <input 
                                type={showCPassword ? "text" : "password"}
                                value={cpassword}
                                onChange={(e) => setCpassword(e.target.value)}
                                placeholder=""
                                id="float_cpassword" 
                                className="block w-full text-sm text-gray-900 bg-transparent rounded-lg border border-[#49bef3] appearance-none dark:border-[#49bef3] focus:outline-none focus:ring-0 focus:border-blue-600 peer dark:focus:border-blue-500" 
                            />
                            <label 
                                htmlFor="float_cpassword" 
                                className="absolute text-sm text-[#49bef3] dark:text-[#49bef3] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
                                Confirm New Password
                            </label> 
                            <div
                                className="absolute inset-y-0 right-2 flex items-center cursor-pointer"
                                onClick={toggleCPasswordVisibility}
                            >
                                {showCPassword ? <Eye size={18} color='#49bef3' /> : <EyeOff size={18} color='#49bef3' />}
                            </div>
                        </div>
                        
                        <div className='flex items-center justify-between'>
                            <button
                                type="submit"
                                className="w-[150px] flex gap-1 items-center bg-[#49bef3] hover:bg-blue-700 text-white py-[6px] px-6 rounded-[50px] text-sm border-2 border-blue-500 justify-center m-auto"
                            >
                                <RotateCcw size={20} />
                                Reset
                            </button>
                        </div>
                    </form>
                </CardContent>
            </Card>
            <ToastContainer />
        </div>
    );
}